// extracted by mini-css-extract-plugin
export default {"agenciesList":"agencies-list_agenciesList__SE2N2","row":"agencies-list_row__Dqhhs","cellCount":"agencies-list_cellCount__DKCP-"};